import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ServiceLayer } from 'src/app/services/serviceLayer';
import * as _ from 'lodash';
import { DAO } from 'src/app/modal/DAO';
import { ConfirmationService } from 'primeng/api';
import { DomSanitizer } from '@angular/platform-browser';
import { Settings } from '../../../services/settings';

@Component({
  selector: 'app-evidence-of-insurance',
  templateUrl: './evidence-of-insurance.component.html',
  styleUrls: ['./evidence-of-insurance.component.css']
})
export class EvidenceOfInsuranceComponent implements OnInit {
  @Input() PolicyQuotesList: any = [];
  public filteredList = [];
  public PolicyorName: any = "";
  public policyDetails: any = {};
  public evidenceDetails: any = {};
  public financialInterestData = [];
  @Output() popupClose = new EventEmitter<any>();
  public isShowError:boolean=false;
  public errorMsg:string='Interest type must be selected'
  public EvidencePDFURL:string='';
  public interest:string='';
  public IsBFMInternal: boolean = false;
  public IsLoading : boolean = false;
  @Input() isFromManagePolicy:boolean=false;
  @Input() isShowEvidence:boolean=false;
  @Input() currentPolicyDetail:any;
  @Input() tempPolicyList:any;

  constructor(public serviceLayer:ServiceLayer, private sanitizer: DomSanitizer,public dao:DAO,public confirmationService:ConfirmationService,private setting: Settings) { }

  async ngOnInit(){
    this.IsLoading = true; 
    try {
      var loginDetails = JSON.parse(window.localStorage.getItem("loginUserDetails"));
      if(loginDetails?.isinternal && (loginDetails?.email).includes("@berkleymarine.com")){
        this.IsBFMInternal = loginDetails?.isinternal;
      }
      if(!this.isFromManagePolicy){
        this.PolicyQuotesList = await this.serviceLayer.getSearchPoliciesList('Policy');
        this.tempPolicyList = this.PolicyQuotesList;
        await this.serviceLayer.getUnderWriterInformation();    
        var currentPolicyDetails = window.localStorage.getItem("currentPolicy");
        var currentPolicyType = window.localStorage.getItem("policyType");
        if (currentPolicyType == 'Request Evidence of insurance' && currentPolicyDetails != undefined && currentPolicyDetails != null && currentPolicyDetails != "" && currentPolicyDetails != "null") {
          currentPolicyDetails = JSON.parse(currentPolicyDetails);
          window.localStorage.setItem("currentPolicy",  null);
          this.PolicyorName = currentPolicyDetails['policyNumber'];
          this.filterPolicy();
        }
      }
      else{
        this.openPopup(this.currentPolicyDetail);
      }
    }catch (error) {
    console.error("Error during init:", error);
  } finally {
    this.IsLoading = false; // hide spinner once all done
  }
  }
  CreateOnlineQuote() {
    let quoteURL = this.setting.quickQuotePolicyUrl + 'Questions/BFM/BR/';
    window.open(quoteURL);
  }
  filterPolicy() {
    this.filteredList = [];
    if (this.PolicyorName != "" && this.PolicyorName.length > 2 && this.tempPolicyList != undefined && this.tempPolicyList != null && this.tempPolicyList.length>0) {
      this.PolicyQuotesList = this.tempPolicyList.filter(policy => policy.typeName == 'Policy' && (((policy.policyNumber != null) && (policy.policyNumber).toLowerCase().includes(this.PolicyorName)) || ((policy.nameInsured != null) && policy.nameInsured.toLowerCase().includes(this.PolicyorName.toLowerCase()))));
      if (this.PolicyQuotesList.length > 0) {
        this.filteredList = this.PolicyQuotesList.slice(0, 10);
      }
    }
    else {
      this.filteredList = [];
    }
  }
  async openEvidenceOfInsurance(policy,i){    
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }
    this.policyDetails = await this.serviceLayer.getPolicyDetails(policy.policyNumber,policy.policyMod);
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    this.financialInterestData = [];
    if(this.policyDetails?.clientInfo?.financialInterest?.interestTypes?.length > 0){
      this.policyDetails?.clientInfo?.financialInterest?.interestTypes?.map((v,i)=>{
          v.TempinterestID = v.interestID == "0" ? i : v.interestID;
      })
      let tempFinancial = _.cloneDeep(_.sortBy(this.policyDetails?.clientInfo?.financialInterest?.interestTypes, [function(o) { return o.interestType; }]));      
      if(tempFinancial?.length > 0){
        tempFinancial.forEach(f=>{
          if(this.financialInterestData?.length > 0 && this.financialInterestData?.filter(c=>c.interestType == f.interestType).length > 0){
            f.interestType = '';
          }          
          this.financialInterestData.push(f);
        });        
      }
    }
    this.evidenceDetails = {};
    this.isShowError = false;
    this.isShowEvidence = true;
    this.dao.agencyCode = this.policyDetails?.agencyInfo?.code;
    this.dao.policyNumber = policy.policyNumber;
    this.dao.insuredName = policy.nameInsured;
    let userData :any = {};
    userData.Email = this.dao?.loginUserDetail?.email;
    userData.AgencyCode = this.policyDetails?.agencyInfo?.code;
    userData.PolicyNumber = this.dao.policyNumber;
    userData.InsuredName = this.dao.insuredName;
    userData.ProgressToPage = window.localStorage.getItem("policyType");
    let payloadDetail:any = {};
    payloadDetail.endPointURL = await this.serviceLayer.getEndPoint("ManagePolicy", "PolicyDetails", [this.dao.loginUserDetail.userCompany,this.dao.policyNumber,50]);
    payloadDetail.payload = "";
    payloadDetail.response = this.policyDetails;
    userData.Payload = JSON.stringify(payloadDetail);
    userData.TransactionStatus = this.policyDetails ? "Success" : "Error";
    userData.RateOnly = false;
    userData.ActionType = "Open Evidence Details";
    this.serviceLayer.postUserActivity(userData);
  }
  openPopup(policyDetails){
    this.policyDetails = _.cloneDeep(policyDetails);
    this.financialInterestData = [];
    if(this.policyDetails?.clientInfo?.financialInterest?.interestTypes?.length > 0){
      this.policyDetails?.clientInfo?.financialInterest?.interestTypes?.map((v,i)=>{
        v.TempinterestID = v.interestID == "0" ? i : v.interestID;
    })
      let tempFinancial = _.cloneDeep(_.sortBy(this.policyDetails?.clientInfo?.financialInterest?.interestTypes, [function(o) { return o.interestType; }]));      
      if(tempFinancial?.length > 0){
        tempFinancial.forEach(f=>{
          if(this.financialInterestData?.length > 0 && this.financialInterestData?.filter(c=>c.interestType == f.interestType).length > 0){
            f.interestType = '';
          }
          this.financialInterestData.push(f);
        });        
      }
    }
    this.evidenceDetails = {};
    this.isShowError = false;
    this.isShowEvidence = true;
  }
  paginate(event) {
    this.filteredList = this.PolicyQuotesList.slice((event.page) * 10, (event.page) * 10 + 10);
  }
  async submitEvidence(){    
    // if(this.evidenceDetails?.interestType != undefined && this.evidenceDetails?.interestType != ''){
      this.confirmationService.confirm({
        message: 'Do you want to confirm the Request ?',
        header: 'Evidence of Insurance',
        accept: async () => {
          await this.evidenceSubmit();
          this.closeEvidence();
          }
      });      
    // }
    // else{
    //   this.isShowError = true;
    // }
  }
  async evidenceSubmit(){
    var element = document.getElementById("GettingID");
    if(element != undefined && element != null) {
      element.classList.add("calculateLbl");
    }          
    let EvidenceData:any={};
    EvidenceData = _.cloneDeep(this.policyDetails);
    if(this.evidenceDetails?.interestType != undefined && this.evidenceDetails?.interestType !== ''){
      this.evidenceDetails.interestID = this.evidenceDetails?.interestType;
      this.evidenceDetails.interestType = this.policyDetails?.clientInfo?.financialInterest?.interestTypes?.filter(c=>c.TempinterestID == this.evidenceDetails.interestID)[0].interestType;
      this.evidenceDetails.interestTypeCode = this.policyDetails?.clientInfo?.financialInterest?.interestTypesOptions?.filter(c=>c.text == this.evidenceDetails?.interestType)[0].code;
    }    
    EvidenceData.evidenceDetails = this.evidenceDetails;
    let currentPolicy = this.PolicyQuotesList.filter(t=>t.policyNumber == this.policyDetails.policyNumber)[0];          
    await this.serviceLayer.RequestEvidence(EvidenceData,this.dao.loginUserDetail?.given_name+" "+this.dao.loginUserDetail?.family_name,currentPolicy?.nameInsured,currentPolicy?.policyNumber,currentPolicy?.companyCode,currentPolicy?.productCode,currentPolicy?.referenceNumber);
    let UrlData = await this.serviceLayer.EvidencePDF(EvidenceData);
    let PDFData = UrlData;
    if (PDFData != null) {
        var arrrayBuffer = this.serviceLayer.base64ToArrayBuffer(PDFData?.pdfStream);
        var blob = new Blob([arrrayBuffer], { type: "application/pdf" });
        var link = window.URL.createObjectURL(blob);
        this.EvidencePDFURL = link;
        window.open(link, '');
    }
    if(element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
  }
  closeEvidence(){
    this.isShowEvidence = false;
    this.evidenceDetails = {};
    this.isShowError = false;
    if(this.isFromManagePolicy){
      this.popupClose.emit();
    }
  }  
  clickDocument(){
    this.serviceLayer.openLink('documentCenter','',this.policyDetails?.policyNumber);
  }
  async searchForPolicy() {
    
    if(this.PolicyorName != undefined && this.PolicyorName != null && this.PolicyorName.length >0){
      var policyQuotesList : any =[];
      policyQuotesList = await this.serviceLayer.getPoliciesBasedOnSearch(this.dao.loginUserDetail.email,this.PolicyorName);
      
      if(policyQuotesList != undefined && policyQuotesList != null && policyQuotesList.length>0) {
        var policyList = policyQuotesList.filter(s => s.typeName == 'Policy');
      }
      var WantToList = [
        { "label": "Report a claim", "value": "Report a claim", "disabled": false },
        { "label": "Manage a policy", "value": "Manage my policy", "disabled": false },
        { "label": "Request Evidence of insurance", "value": "Request Evidence of insurance", "disabled": false },
        { "label": "Cancel a policy", "value": "Cancel my policy", "disabled": false }
      ];
      if (policyList != undefined && policyList.length > 0) {
        policyList.forEach(policy => {
          policy['wantedTo'] = _.cloneDeep(WantToList);
          if (['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION', 'EXPIRED'].includes(policy.status.toUpperCase())) {
            policy['wantedTo'][3].disabled = true;
          }
        });
      }
      this.PolicyQuotesList = policyQuotesList; 
      this.tempPolicyList = policyQuotesList;
      window.localStorage.setItem("policyQuotesList", JSON.stringify(policyQuotesList));
      this.filterPolicy();
    }
  }
}
